import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import get from 'lodash/get';
import TargetingTab from '../../components/organisms/TargetingTab/index';

class TargetingTabContainer extends Component {
  state = {
    activeMenus: null,
  };

  componentDidUpdate(prevProps) {
    // Only set the menus to state on load
    if (this.state.activeMenus === null && prevProps.activeMenus !== this.props.activeMenus) {
      this.setState({ activeMenus: this.props.activeMenus });
    }
  }

  changeActiveKey = key => {
    this.setState({ activeMenus: key });
  };

  render() {
    return (
      <TargetingTab
        {...this.props}
        changeActiveKey={this.changeActiveKey}
        activeMenus={this.state.activeMenus}
      />
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { revisionId },
    },
  }
) => {
  const activeMenus = [];

  const lists = ['Location', 'State', 'Dma', 'App', 'Beacon', 'Chain'];
  const headerLengths = {};
  const resource = revisionId ? 'forecastRevision' : 'advertiserAd';

  lists.forEach(list => {
    const listLength = get(state, `resource.${resource}${list}.count`, 0);
    headerLengths[list] = listLength || 0;

    if (listLength) {
      activeMenus.push(list);
    }
  });

  // Since chains are shown on the same line as locations
  const chainLength = get(state, `resource.${resource}Chain.count`);
  if (chainLength && !activeMenus.includes('Location')) {
    activeMenus.push('Location');
  }

  // Since Dmas are shown on the same line as states
  const dmaLength = get(state, `resource.${resource}Dma.count`);
  if (dmaLength && !activeMenus.includes('State')) {
    activeMenus.push('State');
  }

  return {
    isPolling: get(state, 'audiences.pollingForQuery'),
    headerLengths,
    activeMenus,
  };
};

const mapDispatchToProps = () => ({});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TargetingTabContainer);
